// Table column

import { TField } from "../components/forms/DynamicForm"

export const PAYMENT_BLOTTER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'paymentNo',
        label: 'Payment No',
    },
    {
        id: 'customer',
        label: 'Customer',
    },
    {
        id: 'customerName',
        label: 'Customer Name',
    },
    {
        id: 'dgTxnRefNo',
        label: 'DG Txn Ref No',
    },
    {
        id: 'type',
        label: 'Type',
    },
    {
        id: 'amount',
        label: 'Amount',
    },
    {
        id: 'creator',
        label: 'Creator',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'valueDate',
        label: 'Value Date',
    },
    {
        id: 'transactionRRN',
        label: 'Transaction RRN',
    },
    {
        id: 'paymentRef',
        label: 'Payment Ref',
    },
    {
        id: 'bankName',
        label: 'Bank Name',
    },
    {
        id: 'ifsc',
        label: 'IFSC',
    },
    {
        id: 'amountNumber',
        label: 'Amount Number',
    },
    {
        id: 'beneficiaryName',
        label: 'Beneficiary Name',
    },
    {
        id: 'vpa',
        label: 'VPA',
    },
    {
        id: 'remarks',
        label: 'Remarks',
    },
    {
        id: 'transactionType',
        label: 'Transaction Type',
    },
    {
        id: 'paymentPartner',
        label: 'Payment Partner',
    },
]

export const BILLING_BLOTTER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'agingInDays',
        label: 'Aging In Days',
    },
    {
        id: 'billingNo',
        label: 'Billing No',
    },
    {
        id: 'customer',
        label: 'Customer',
    },
    {
        id: 'customerName',
        label: 'Customer Name',
    },
    {
        id: 'type',
        label: 'Type',
    },
    {
        id: 'total',
        label: 'Total',
    },
    {
        id: 'totalPending',
        label: 'Total Pending',
    },
    {
        id: 'creator',
        label: 'Creator',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'gtNumber',
        label: 'GT Number',
    },
    {
        id: 'gtTransactionType',
        label: 'GT Transaction Type',
    },
    {
        id: 'remarks',
        label: 'Remarks',
    },
]

export const INVENTORY_ADJUST_BLOTTER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: "adjustmentNo",
        label: 'Adjustment No',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: "transactionType",
        label: 'Transaction Type',
    },
    {
        id: 'reasonCode',
        label: 'Reason Code',
    },
    {
        id: "BU",
        label: 'BU',
    },
    {
        id: 'location',
        label: 'Location',
    },
    {
        id: "subInventory",
        label: 'Sub Inventory',
    },
    {
        id: 'locator',
        label: 'Locator',
    },
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'documentReference',
        label: 'Document Reference',
    },
    {
        id: "buReference",
        label: 'BU Reference',
    },
    {
        id: 'gtNumber',
        label: 'GT Number',
    },
    {
        id: "gtTransactionType",
        label: 'GT Transaction Type',
    },
]

export const PHYSICAL_BLOTTER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'physicalOrderNo',
        label: 'Physical Order No',
    },
    {
        id: 'transactionLocation',
        label: 'Transaction Location',
    },
    {
        id: 'customer',
        label: 'Customer',
    },
    {
        id: 'operation',
        label: 'Operation',
    },
    {
        id: 'ticketValue',
        label: 'Ticket Value',
    },
    {
        id: 'settlementMethod',
        label: 'Settlement Method',
    },
    {
        id: 'physicalOrderDate',
        label: 'Physical Order Date',
    },
    {
        id: 'requestedShipDate',
        label: 'Requested Ship Date',
    },
    {
        id: 'deliveryDate',
        label: 'Delivery Date',
    },
    {
        id: 'buRefNo',
        label: 'BU Ref No.',
    },
    {
        id: 'fulfillmentLocation',
        label: 'Fulfillment Location',
    },
    {
        id: 'creator',
        label: 'Creator',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'partnerBuid',
        label: 'Partner Buid',
    },
    {
        id: 'remarks',
        label: 'Remarks',
    },
]

export const DELIVERY_BLOTTER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'deliveryNo',
        label: 'Delivery No',
    },
    {
        id: 'shipmentDate',
        label: 'Shipment Date',
    },
    {
        id: 'customer',
        label: 'Customer',
    },
    {
        id: 'transporter',
        label: 'Transporter',
    },
    {
        id: 'physicalOrderNo',
        label: 'Physical Order No.',
    },
    {
        id: 'trackingNo',
        label: 'Tracking No',
    },
    {
        id: 'exciseInvoiceNo',
        label: 'Excise Invoice No',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'deliveryType',
        label: 'Delivery Type',
    },
    {
        id: 'partnerOrderId',
        label: 'Partner Order Id',
    },
    {
        id: 'partnerBuid',
        label: 'Partner Buid',
    },
    {
        id: 'remarks',
        label: 'Remarks',
    },
    {
        id: 'synchronizedAt',
        label: 'Synchronized At',
    },
    {
        id: 'deliveryPartnerUpdateDate',
        label: 'Delivery Partner Update Date',
    },
    {
        id: 'trackStatusDescription',
        label: 'Track Status Description',
    },
    {
        id: 'trackStatusCode',
        label: 'Track Status Code',
    },
    {
        id: 'trackingDetails',
        label: 'Tracking Details',
    },
]

export const TRADE_BLOTTER_BU_TRADES_FIELDS = [
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'dealNo',
        label: 'Deal No.',
    },
    {
        id: 'customer',
        label: 'Customer',
    },
    {
        id: 'currencyPair',
        label: 'Currency Pair',
    },
    {
        id: 'product',
        label: 'Product',
    },
    {
        id: 'operation',
        label: 'Operation',
    },
    {
        id: 'quantity',
        label: 'Quantity',
    },
    {
        id: 'totalOz',
        label: 'Total Oz',
    },
    {
        id: 'dealtPrice',
        label: 'Dealt Price',
    },
    {
        id: 'marketPrice',
        label: 'Market Price',
    },
    {
        id: 'dealtPriceCpLeg1Fld',
        label: 'Dealt PriceCpLeg1_Fld',
    },
    {
        id: 'dealtPriceCpLeg2',
        label: 'Dealt Price CpLeg2',
    },
    {
        id: 'marketPriceCpLeg1',
        label: 'Market Price CpLeg1',
    },
    {
        id: 'marketPriceCpLeg2',
        label: 'Market Price CpLeg2',
    },
    {
        id: 'dealType',
        label: 'Deal Type',
    },
    {
        id: 'channel',
        label: 'Channel',
    },
    {
        id: 'tradeDate',
        label: 'Trade Date',
    },
    {
        id: 'createDate',
        label: 'Create Date',
    },
    {
        id: 'hedgeRef',
        label: 'Hedge Ref',
    },
    {
        id: 'user',
        label: 'User',
    },
    {
        id: 'remarks',
        label: 'Remarks',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'platformRef',
        label: 'Platform Ref',
    },
    {
        id: 'partnerBuid',
        label: 'Partner Buid',
    },
    {
        id: 'physicalOrderNo',
        label: 'Physical Order No',
    },
    {
        id: 'inboundNo',
        label: 'Inbound No',
    },

]

export const TRADE_BLOTTER_HEDGE_TRADES_FIELDS = [
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'dealNo',
        label: 'Deal No.',
    },
    {
        id: 'isBooked',
        label: 'Is Booked',
    },
    {
        id: 'customer',
        label: 'Customer',
    },
    {
        id: 'currencyPair',
        label: 'Currency Pair',
    },
    {
        id: 'product',
        label: 'Product',
    },
    {
        id: 'operation',
        label: 'Operation',
    },
    {
        id: 'quantity',
        label: 'Quantity',
    },
    {
        id: 'totalOz',
        label: 'Total Oz',
    },
    {
        id: 'dealtPrice',
        label: 'Dealt Price',
    },
    {
        id: 'marketPrice',
        label: 'Market Price',
    },
    {
        id: 'dealType',
        label: 'Deal Type',
    },
    {
        id: 'channel',
        label: 'Channel',
    },
    {
        id: 'tradeDate',
        label: 'Trade Date',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'valueDate',
        label: 'Value Date',
    },
    {
        id: 'hedgeRef',
        label: 'Hedge Ref',
    },
    {
        id: 'user',
        label: 'User',
    },
    {
        id: 'platformName',
        label: 'Platform Name',
    },
    {
        id: 'remarks',
        label: 'Remarks',
    },
  
]

export const TRANSFER_BLOTTER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: "status",
        label: 'Status',
    },
    {
        id: 'transferNo',
        label: 'Transfer No',
    },
    {
        id: 'sreBusinessUnit',
        label: 'Sre Business Unit',
    },
    {
        id: 'quantity',
        label: 'Quantity',
    },
    {
        id: 'price',
        label: 'Price',
    },
    {
        id: 'totalPrice',
        label: 'Total Price',
    },
    {
        id: 'srcBalance',
        label: 'Src Balance',
    },
    {
        id: 'transferRefNo',
        label: 'Transfer Ref No',
    },
    {
        id: 'transactionDate',
        label: 'Transaction Date',
    },
    {
        id: 'executionDate',
        label: 'Execution Date',
    },
    {
        id: 'expiryDate',
        label: 'Expiry Date',
    },
    {
        id: 'partnerBuid',
        label: 'Partner Buid',
    },
    
]

export const INBOUND_BLOTTER_FIELDS = [
    {
        id: "action",
        label: 'Action',
    },
    {
        id: 'inboundNo',
        label: 'Inbound No',
    },
    {
        id: 'customer',
        label: 'Customer',
    },
    {
        id: 'customerName',
        label: 'Customer Name',
    },
    {
        id: 'creationDate',
        label: 'Creation Date',
    },
    {
        id: 'creator',
        label: 'Creator',
    },
    {
        id: 'customerReference',
        label: 'Customer Reference',
    },
    {
        id: 'gtNumber',
        label: 'GT Number',
    },
    {
        id: 'gtTransactionType',
        label: 'GT Transaction Type',
    },
    {
        id: 'transactionLocation',
        label: 'Transaction Location',
    },
    {
        id: "status",
        label: 'Status',
    }
]

export const SEARCH_PAYMENT_BLOTTER_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(15% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(15% - 20px)'
    },
    {
        fieldName: 'status',
        isVisible: true,
        fieldType: 'text',
        label: 'Status',
        fullWidth: false,
        width: 'calc(15% - 20px)'
    },
    {
        fieldName: 'partnerBuid',
        isVisible: true,
        fieldType: 'text',
        label: 'PartnerBuid',
        fullWidth: false,
        width: 'calc(15% - 20px)'
    },
    {
        fieldName: 'refundDetails',
        isVisible: true,
        fieldType: 'autocomplete',
        options: [{ value: 1, label: 'ABC' }],
        label: 'Refund Details',
        fullWidth: false,
        width: 'calc(15% - 20px)'
    },
    {
        fieldName: 'offlineCollection',
        isVisible: true,
        fieldType: 'checkbox',
        label: 'Offline Collection',
        fullWidth: false,
        width: 'calc(15% - 20px)'
    },
]

export const SEARCH_BILLING_BLOTTER_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'status',
        isVisible: true,
        fieldType: 'text',
        label: 'Status',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'partnerBuid',
        isVisible: true,
        fieldType: 'text',
        label: 'PartnerBuid',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'billingNo',
        isVisible: true,
        fieldType: 'text',
        label: 'Billing No.',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },

]

export const SEARCH_DELIVERY_BLOTTER_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'status',
        isVisible: true,
        fieldType: 'text',
        label: 'Status',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'partnerBuid',
        isVisible: true,
        fieldType: 'text',
        label: 'PartnerBuid',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'deliveryNo',
        isVisible: true,
        fieldType: 'text',
        label: 'Delivery No.',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },

]

export const SEARCH_PHYSICAL_BLOTTER_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'status',
        isVisible: true,
        fieldType: 'text',
        label: 'Status',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'partnerBuid',
        isVisible: true,
        fieldType: 'text',
        label: 'PartnerBuid',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'order',
        isVisible: true,
        fieldType: 'text',
        label: 'Order',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },

]

export const SEARCH_TRANSFER_BLOTTER_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'status',
        isVisible: true,
        fieldType: 'text',
        label: 'Status',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'partnerBuid',
        isVisible: true,
        fieldType: 'text',
        label: 'PartnerBuid',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },

]

export const SEARCH_INBOUND_BLOTTER_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'transactionLocation',
        isVisible: true,
        fieldType: 'text',
        label: 'Transaction Location',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },
    {
        fieldName: 'customer',
        isVisible: true,
        fieldType: 'text',
        label: 'Customer',
        fullWidth: false,
        width: 'calc(20% - 20px)'
    },

]

export const SEARCH_TRADE_BLOTTER_FIELDS: TField<any>[] = [
    {
        fieldName: 'dateFrom',
        isVisible: true,
        fieldType: 'date',
        label: 'Date From',
        fullWidth: false,
        width: 'calc(30% - 20px)'
    },
    {
        fieldName: 'dateTo',
        isVisible: true,
        fieldType: 'date',
        label: 'Date To',
        fullWidth: false,
        width: 'calc(30% - 20px)'
    },
    {
        fieldName: 'status',
        isVisible: true,
        fieldType: 'text',
        label: 'Status',
        fullWidth: false,
        width: 'calc(30% - 20px)'
    },
]